import React from 'react';
import styled from 'styled-components';
import { round } from 'lodash';

import RevenueSummaryPaneFragment from './RevenueSummaryPaneFragment';
import { divideIntoNumericDigits } from '../../utils/common';

const SummaryPaneContainer = styled.div`
  display: flex;
  align-items: start;
  padding: 15px 0;
  border-style: solid;
  border-width: 1px 0;
`;

const calcResult = (num, total) => {
  const percent = Math.floor((num * 100) / total) / 100;
  return Number.isFinite(percent) ? percent : 0;
};

const RevenueSummaryPane = ({ executing, revenue, payers, uniqueUsers, currencySymbol }) => (
  <SummaryPaneContainer>
    {!executing && !revenue && !payers && !uniqueUsers ? (
      <span>No data yet</span>
    ) : (
      [
        <RevenueSummaryPaneFragment
          key="revenue"
          executing={executing && !revenue}
          value={`${currencySymbol} ${divideIntoNumericDigits(round(revenue, 2))}`}
          description="Revenue"
        />,
        <RevenueSummaryPaneFragment
          key="payers"
          executing={executing && !payers}
          value={divideIntoNumericDigits(payers)}
          description="Payers"
        />,
        <RevenueSummaryPaneFragment
          key="arppu"
          executing={executing && (!revenue || !payers)}
          value={`${currencySymbol} ${divideIntoNumericDigits(calcResult(revenue, payers))}`}
          description="ARPPU"
        />,
        <RevenueSummaryPaneFragment
          key="arpu"
          executing={executing && (!uniqueUsers || !uniqueUsers)}
          value={`${currencySymbol} ${divideIntoNumericDigits(calcResult(revenue, uniqueUsers))}`}
          description="ARPU"
        />,
      ]
    )}
  </SummaryPaneContainer>
);

export default RevenueSummaryPane;
